import React from 'react'
import { withTheme } from 'styled-components'
import { Modal } from 'antd'

import { Text, Paragraph } from './Text'
import { FlexColumn } from './Container'
import { Button } from './Button'
import fatal_error from '../../Images/pluto-fatal-error.png'

export const FAQModal = (props) => {
    var { type, title, description, theme, subTitle } = props
    var childViews
    if (type === "getting-started") {
        subTitle = "Getting Started"
        title = "Things you need to know"
        description = "Get the best out of your Aion account"
        const contentItems = [
            {
                title: <span>Pay your bills for <span style={{ color: theme.colors.secondary4 }}>free</span> with ACH, Bill Pay or Checks</span>,
            },
            {
                title: <span>Accept digital payments, <span style={{ color: theme.colors.secondary4 }}>free</span> and <span style={{ color: theme.colors.secondary4 }}>unlimited</span></span>,
            },
            {
                description: <span style={{ fontSize: "1.1rem" }}>Please note that during the first 30 days of your new account:</span>
            },
            // {
            //     title: "Opening Deposit",
            //     description: "You’ll see your opening deposit posted to the account within 2-3 business days. The deposit is held for 5 business days for your security."
            // },
            // {
            //     title: "Debit Card",
            //     description: "A debit card is issued on account opening. Please allow 7-10 business days for the card to reach you at your business mailing address."
            // },
            {
                title: "Mobile Deposits",
                description: "Mobile check deposits are held for 5 business days. After 30 days, this will change to 2 business days."
            },
            {
                title: "Incoming ACH Debits",
                description: "Transfers from other financial institutions are held for 5 business days. After 30 days, this will change to 2 business days."
            },
            {
                title: "Outgoing ACH Payments",
                description: "The daily cut-off time for ACH payments is 6:30 pm ET. Payments created after this time are processed the next business day."
            },
            {
                title: "Wire Payments",
                description: "The daily cut-off time for Wire payments is 3:00 pm ET. Payments created after this time are processed the next business day."
            }
        ]
        childViews = []
        contentItems.forEach((item, i) => childViews.push(<FlexColumn key={i} left>
            <Text theme={theme} heading>{item.title}</Text>
            <Text theme={theme} lightText margin='0 0 16px'>{item.description}</Text>
        </FlexColumn>))
    }
    Modal.info({
        title: subTitle,
        content: (
            <FlexColumn start>
                <FlexColumn start style={{ margin: "20px 0 10px 0" }} >
                    <Text theme={theme} heading>{title}</Text>
                    <Text theme={theme} lightText>{description}</Text>
                </FlexColumn>
                {childViews}
            </FlexColumn>
        ),
        okButtonProps: { size: "large" },
        style: { top: 10 },
        okText: "Got It",
        ...props,
        width: 800,
        destroyOnClose: true
    })
}

export const LockedAccountModalContent = (props) => {
    var { theme, lockType } = props
    return (
        <FlexColumn center style={{ minHeight: "100vh" }}>
            <FlexColumn left start style={{ width: "1400px", padding: "50px", borderRadius: "5px" }}>
                <img
                    src={fatal_error}
                    width={350}
                    alt="image"
                    style={{ marginBottom: "50px", alignSelf: "center" }}
                />
                <Text>Your bank account is currently frozen for security reasons. We take proactive measures to protect your funds and ensure your financial safety. Reach out to us at contact@aionfi.com for more details or next steps. </Text>
                <Button solid permtype="Override" onClick={() => props.onConfirm()} text='Got It' margin='12px 0 0' />
            </FlexColumn>
        </FlexColumn>
    )
}